import { boolean, object, string } from 'yup';
import './utils/email';

export const CommonApplicantValidation = object().shape({
  firstName: string().required('validations.first_name.required'),
  lastName: string().required('validations.last_name.required'),
  email: string()
    .email('validations.email.format')
    .required('validations.email.required'),
});

export const UnemployedValidation = CommonApplicantValidation.shape({
  phone: string()
    .matches(/^(\+3[1-9])\s?\d{8,9}$/, {
      message: 'validations.phone.format',
      excludeEmptyString: true,
    })
    .required('validations.phone.required'),
  registerNumber: string().required('validations.register_number.required'),
});

export const CompanyValidation = CommonApplicantValidation.shape({
  phone: string().matches(/^(\+3[1-9])\s?\d{8,9}$/, {
    message: 'validations.phone.format',
    excludeEmptyString: true,
  }),
  companyNumber: string()
    .notRequired()
    .test('format', 'validations.company_name.format', (value) => {
      if (value && !/^\d{4}\.\d{3}\.\d{3}$/.test(value)) {
        return false;
      }
      return true;
    }),
  companyName: string().required('validations.company_name.required'),
});

export const TeacherValidation = CommonApplicantValidation.shape({
  phone: string().matches(/^(\+3[1-9])\s?\d{8,9}$/, {
    message: 'validations.phone.format',
    excludeEmptyString: true,
  }),
  institution: string().required('validations.institution.required'),
  cooperationAgreement: boolean().required(
    'validations.cooperation_agreement.required'
  ),
});
